var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Remove / Large / 48") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Remove-/-Large-/-48"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "background",
    fillOpacity: 0,
    fill: "#000000",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeLinecap: "square",
    transform: "translate(15.600000, 15.600000)",
    stroke: "#111111"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8,8.8817842e-14 L8.8817842e-14,16.8 M16.8,16.8 L8.8817842e-14,8.8817842e-14",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove48);
export default __webpack_public_path__ + "static/media/remove48.422cf332d4d3f968f3e8fd7abf43522d.svg";
export { ForwardRef as ReactComponent };